import { NgModule, DEFAULT_CURRENCY_CODE, LOCALE_ID } from '@angular/core';

import { AppComponent } from './app.component';

import { ToastrModule } from 'ngx-toastr';
import { PaginaNaoEncontradaComponent } from './pagina-nao-encontrada.component';

import { JwtModule } from "@auth0/angular-jwt";
import { AppRoutingModule } from './app-routing.module';
import { NavbarComponent } from './core/navbar/navbar.component';

import { CoreModule } from './core/core.module';

import { SegurancaModule } from './seguranca/seguranca.module';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';
import { DashboardModule } from './dashboard/dashboard.module';
import { FinanceiroModule } from './financeiro/financeiro.module';
import { SecretariaModule } from './secretaria/secretaria.module';
import { RecepcaoModule } from './recepcao/recepcao.module';
import { JuridicoModule } from './juridico/juridico.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import ptBr from '@angular/common/locales/pt';
import { CommonModule, registerLocaleData } from '@angular/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { RequerimentosModule } from './requerimentos/requerimentos.module';
import { CarteirinhaModule } from './carteirinha/carteirinha.module';

registerLocaleData(ptBr);

export function tokenGetter() {
  return localStorage.getItem("access_token_xmanager");
}

@NgModule({
  declarations: [
    AppComponent,
    PaginaNaoEncontradaComponent,
    NavbarComponent

  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    DialogModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
    DropdownModule,
    InputMaskModule,
    RequerimentosModule,
    CarteirinhaModule,

    ToastrModule.forRoot(),
    JwtModule.forRoot({
      config: {
        tokenGetter
      }
    }),

    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    }),
    TableModule,
    ConfirmDialogModule,
    CoreModule,
    SegurancaModule,
    DashboardModule,
    FinanceiroModule,
    SecretariaModule,
    RecepcaoModule,
    JuridicoModule,

    AppRoutingModule
  ],
  providers: [
    ConfirmationService,
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader{
  return new TranslateHttpLoader(http);
}
